import { FC } from 'react';
import { MBox, MText } from '../../../../../components/Monetize';
import {
  QuoteDocumentsMode,
  ROW_GRID_TEMPLATE_COLUMNS,
  SETTINGS_ROW_GRID_TEMPLATE_COLUMNS,
} from './constants';

interface QuoteDocumentListHeaderProps {
  mode: QuoteDocumentsMode;
}

const headerLabelProps = {
  fontWeight: 'semibold',
  textTransform: 'uppercase',
  letterSpacing: 'wide',
  color: 'tGray.darkPurple',
} as const;

export const QuoteDocumentListHeader: FC<QuoteDocumentListHeaderProps> = ({
  mode,
}) => (
  <MBox
    display="grid"
    gridTemplateColumns={
      mode === QuoteDocumentsMode.SETTINGS
        ? SETTINGS_ROW_GRID_TEMPLATE_COLUMNS
        : ROW_GRID_TEMPLATE_COLUMNS
    }
    gap={3}
    px={3}
    pb={2}
  >
    <MBox />
    <MText {...headerLabelProps}>Document</MText>
    <MText {...headerLabelProps}>Type</MText>
    {mode === QuoteDocumentsMode.QUOTE && (
      <MText {...headerLabelProps}>Source</MText>
    )}
    {mode === QuoteDocumentsMode.SETTINGS && (
      <MText {...headerLabelProps}>Add to New Quotes</MText>
    )}
    <MText {...headerLabelProps} justifySelf="end">
      Actions
    </MText>
  </MBox>
);
